export default {
  props: {
    cards: {
      type: Array,
      required: false,
      default: function() {
        return [
          {
            image: "/img/icons/maps.svg",
            title: this.$t('gifts.wherever_you_want'),
            copy: this.$t('gifts.why_in_your_city')
          },
          {
            image: "/img/icons/camera.svg",
            title: this.$t('gifts.because_never_before'),
            copy: this.$t('gifts.need_to_see_once')
          },
          {
            image: "/img/icons/money.svg",
            title: this.$t('gifts.cheap'),
            copy: this.$t('gifts.because_cheap')
          }
        ];
      }
    },
    bgColor: {
      type: String,
      required: false,
      default: () => "#001d38"
    },
    textColor: {
      type: String,
      required: false,
      default: () => "#FFFFFF"
    }
  },
  created() {}
};
